module.exports = __webpack_public_path__ + "static/Calque-236-3095ceefa938f243431a30033af3930c.png";